/**
 * Checks if a message is unread. Supports both boolean and string values
 * during transition from boolean to string in DynamoDB.
 * TODO: Remove boolean support once DB migration is complete
 */
export const isUnread = (
  read: boolean | undefined | 'true' | 'false',
): boolean => {
  return read === false || read === 'false'
}
